import React, { useState, useEffect, useCallback } from "react";
import Common from "../Common/common";
import constClass from "../../Constants/Constants";
import axios from "axios";
import Loading from "../Loading/Loading";

const EventInfoList = ({ siteId, mallId, event, eventInfoClick, customerId, liffAccessToken }) => {
  const [granted, setGranted] = useState(false);
  const [checkinData, setCheckinData] = useState(null);
  const [ticketNameList, setTicketNameList] = useState(null);
  const [checkInFlag, setCheckInFlag] = useState(null);
  const [checkInGpsFlag, setCheckInGpsFlag] = useState(null);

  const refreshCheckData = useCallback(async () => {
    try {
      const ticketNameListPromise = axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/ticket/line/${siteId}/namelist/`,
        { customer_id: customerId, line_id: liffAccessToken, mall_id: mallId }
      );
      const ticketNameList = (await ticketNameListPromise).data;

      setTicketNameList(ticketNameList);
      // GPSを取得して再送信
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const data = (
            await axios.post(
              `${process.env.REACT_APP_BACKEND_URL}/event/line/check/${siteId}/`,
              {
                site_id: siteId,
                mall_id: mallId,
                line_id: liffAccessToken,
                event_id: event.event_id,
                lon: longitude,
                lat: latitude,
              }
            )
          ).data;
          if (data && data.result) {
            // 成功時の処理
            const data = (
              await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/event/line/give/${siteId}/`,
                {
                  site_id: siteId,
                  mall_id: mallId,
                  line_id: liffAccessToken,
                  event_id: event.event_id,
                }
              )
            ).data;
            if (data && data.result && !data.ticket && !data.point) {
              setGranted(true);
            } else if (data && !data.result) {
              setGranted(true);
            }
            setCheckinData(data);
          } else if (data && !data.result) {
            setCheckInFlag(true);
          }
        } catch (err) {
          console.log(err);
        }
      },
        (error) => {
          console.log("位置情報が許可されませんでした", error);
          setCheckInFlag(true);
          setCheckInGpsFlag(true);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }, [siteId, mallId, liffAccessToken, event, customerId]);

  useEffect(() => {
    refreshCheckData();
  }, [refreshCheckData]);

  return checkInFlag ? (
    <div className="point_area">
      <div className="checkin_ellipse1"></div>
      <div className="checkin_ellipse2"></div>
      <div className="checkin_ellipse3"></div>
      <div className="group15_1">
        <div className="vector1">★</div>
        <div className="vector2">★</div>
      </div>
      <div className="frame17">
        <div className="acquisition_text">{checkInGpsFlag ? "位置情報が許可されていません" : "獲得条件を満たしていません"}</div>
      </div>
      <div className="group15_2">
        <div className="vector3">★</div>
        <div className="vector4">★</div>
      </div>
    </div>
  ) : checkinData === null || ticketNameList === null ? (
    <Loading />
  ) : (
    <React.Fragment>
      <div className="frame61-center">
        <div className="frame61">
          <div className="checkin_text">チェックイン</div>
          <img src={`/${siteId}/icon-check.png`} alt={"チェック"} />
        </div>
      </div>
      <div className="point_area">
        <div className="checkin_ellipse1"></div>
        <div className="checkin_ellipse2"></div>
        <div className="checkin_ellipse3"></div>
        <div className="group15_1">
          <div className="vector1">★</div>
          <div className="vector2">★</div>
        </div>
        <div className="frame17">
          {granted && <div className="acquisition_text">すでに獲得済み</div>}
          {!granted && (
            <React.Fragment>
              {/* pointのみ */}
              {checkinData.point && !checkinData.ticket && (
                <React.Fragment>
                  <div className="point_area_line">
                    <div className="checkin_point_text">
                      {checkinData.point.point}
                    </div>
                    <div className="acquisition_text">ポイント獲得</div>
                  </div>
                </React.Fragment>
              )}
              {/* ticketのみ */}
              {checkinData.ticket && !checkinData.point && (
                <React.Fragment>
                  <div className="acquisition_text">
                    {ticketNameList.find(
                      (x) => x.ticket_id === checkinData.ticket.ticket_id
                    )
                      ? ticketNameList.find(
                        (x) => x.ticket_id === checkinData.ticket.ticket_id
                      ).ticket_name
                      : ""}
                  </div>
                  <div className="acquisition_text">クーポン獲得</div>
                </React.Fragment>
              )}
              {/* 両方ある場合 */}
              {checkinData.ticket && checkinData.point && (
                <React.Fragment>
                  <div className="point_area_line">
                    <div className="checkin_point_text">
                      {checkinData.point.point}
                    </div>
                    <div className="acquisition_text">ポイント獲得</div>
                  </div>
                  <div className="acquisition_text">
                    {ticketNameList.find(
                      (x) => x.ticket_id === checkinData.ticket.ticket_id
                    )
                      ? ticketNameList.find(
                        (x) => x.ticket_id === checkinData.ticket.ticket_id
                      ).ticket_name
                      : ""}
                    クーポン獲得
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
        <div className="group15_2">
          <div className="vector3">★</div>
          <div className="vector4">★</div>
        </div>
      </div>
      <div className="frame62">
        <div className="frame62_body">
          <div className="notice_list_title">お知らせ一覧</div>
          <div className="notice_list">
            {event &&
              Array.isArray(event.m_event_infos) &&
              event.m_event_infos.length > 0 ? (
              event.m_event_infos.map((checkin, index) => {
                return (
                  <div key={checkin.checkin_id} className="c_card_news">
                    <div className="notice_title_text">
                      {checkin.notice_title}
                    </div>
                    <div className="checkin_box">
                      <div className="mask_group">
                        {checkin.notice_image_url && (
                          <img
                            className="mask_group"
                            src={`/${siteId}/${constClass.CHECKIN_IMAGE_DIR}${checkin.notice_image_url}`}
                            alt={checkin.notice_title}
                            style={{ objectFit: "cover" }}
                          />
                        )}
                        {!checkin.notice_image_url && (
                          <img
                            className="mask_group"
                            src={`/${siteId}/noimage.png`}
                            alt="noimage"
                            style={{ objectFit: "cover" }}
                          />
                        )}
                      </div>
                      <div className="frame15 d-flex flex-column">
                        <div className="frame15_text">
                          {Common.getBrString(checkin.notice_summary)}
                        </div>
                        <button
                          onClick={() => eventInfoClick(checkin.checkin_id)}
                          className="button text-black bg-lightwhite mt-auto"
                        >
                          くわしく見る
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="py-2">お知らせはありません</div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EventInfoList;